import { handleWriteContract } from "@/lib/contractHelper";
import store from "@/store";
import { SpaceId } from "@/types";
import {
  readContract,
  waitForTransaction,
  prepareWriteContract,
} from "@wagmi/core";

const setupConfig = () => {
  const { identity } = store.getState()?.contract?.infoWagmiConfig ?? {};
  return identity;
};

const userRegister = async ({
  name,
  idType,
  idValue,
  refBy = 0,
  phoneNumber = "udf",
  email = "udf",
}: {
  name: string;
  idType: number;
  idValue: string;
  refBy: number;
  email: string;
  phoneNumber: string;
}) => {
  try {
    const { request, result } = await prepareWriteContract({
      ...setupConfig(),
      functionName: "userRegister",
      args: [
        SpaceId.MetaDAP,
        name,
        idType,
        idValue,
        phoneNumber,
        email,
        Number(refBy),
      ],
    });

    const hash = await handleWriteContract(request);

    await waitForTransaction({
      hash,
    });

    return {
      transactionHash: hash,
      soulBoundId: Number(result),
    };
  } catch (err) {
    throw err;
  }
};

const getAccStr = async ({
  spaceId,
  address,
  strIndex,
}: {
  spaceId: number;
  address: string;
  strIndex: number;
}) => {
  try {
    const string = await readContract({
      ...setupConfig(),
      functionName: "getAccStr",
      args: [spaceId, address, strIndex],
    });

    return string;
  } catch (err) {
    throw err;
  }
};

const getAccNum = async ({
  spaceId,
  address,
  numIndex,
}: {
  spaceId: number;
  address: string;
  numIndex: number;
}) => {
  try {
    const number = await readContract({
      ...setupConfig(),
      functionName: "getAccNum",
      args: [spaceId, address, numIndex],
    });
    return Number(number);
  } catch (err) {
    throw err;
  }
};

const accStatusCheck = async ({
  spaceId,
  address,
  statusIndex,
  chainId,
}: {
  spaceId: number;
  address: string;
  statusIndex: number;
  chainId: number;
}) => {
  try {
    const data = await readContract({
      ...setupConfig(),
      functionName: "accStatusCheck",
      args: [spaceId, address, statusIndex, true],
      chainId,
    });
    return data;
  } catch (err) {
    return false;
  }
};

const getAccAddrBySBID = async ({
  spaceId,
  soulBoundID,
}: {
  spaceId: number;
  soulBoundID: string;
}) => {
  try {
    const data = (await readContract({
      ...setupConfig(),
      functionName: "getAccAddrBySBID",
      args: [spaceId, soulBoundID],
    })) as any;
    return data;
  } catch (err) {
    throw err;
  }
};

export const identityService = {
  userRegister,
  getAccStr,
  getAccNum,
  accStatusCheck,
  getAccAddrBySBID,
};
